const shadow = (x = 0, y = 0, b = 0, s = 0, color = "#000000") => {
    return `${x}px ${y}px ${b}px ${s}px ${color}5c`;
};

export default shadow;
